import { createSlice } from "@reduxjs/toolkit";

const templatesSlice = createSlice({
  name: "templates",
  initialState: {
    data: [],
    selectedTemplate: null,
  },
  reducers: {
    setTemplates: (state, action) => {
      state.data = action.payload;
    },
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
    addNewTemplate: (state, action) => {
      state.data.push({
        id: action.payload,
        title: "Untitled",
        system: "",
        message: "",
      });
    },
    deleteTemplateById: (state, action) => {
      const id = action.payload;
      state.data = state.data.filter((t) => t.id !== id);
    },
    updateSystemById: (state, action) => {
      const { id, text } = action.payload;
      const template = state.data.find((t) => t.id === id);
      if (template) {
        template.system = text;
      }
    },
    updateTitleById: (state, action) => {
      const { id, text } = action.payload;
      const template = state.data.find((t) => t.id === id);
      if (template) {
        template.title = text;
      }
    },
    updateMessageById: (state, action) => {
      const { id, text } = action.payload;
      const template = state.data.find((t) => t.id === id);
      if (template) {
        template.message = text;
      }
    },
  },
});

export const {
  setTemplates,
  setSelectedTemplate,
  updateSystemById,
  updateTitleById,
  updateMessageById,
  addNewTemplate,
  deleteTemplateById,
} = templatesSlice.actions;

export default templatesSlice.reducer;
